import classNames from "classnames/bind";
import styles from "./HeaderPromoStrip.module.scss";

import SmartLink from "common/wrapper/SmartLink";
import type { ResolvedPromoContent } from "resolvers/base/promoContentResolver";

const cx = classNames.bind(styles);

export type PromoStripProps = {
    promo: ResolvedPromoContent;
    isInsideMobileMenu?: boolean;
    className?: string;
    oneLine?: boolean;
    prefetch?: boolean;
};

const HeaderPromoStrip: React.FC<PromoStripProps> = ({
    promo,
    className,
    oneLine,
    prefetch = false,
}) => {
    if (!promo.text) return null;

    return promo.link ? (
        <SmartLink href={promo.link} prefetch={!!prefetch}>
            <a className={cx("promoStrip", className)}>
                <div className={cx("widthConstrain")}>
                    <span
                        className={cx("promoText", {
                            oneLine: !!oneLine,
                            promoTextLink: promo.link,
                        })}
                    >
                        {promo.text}
                    </span>
                </div>
            </a>
        </SmartLink>
    ) : (
        <div className={cx("promoStrip", className)}>
            <div className={cx("widthConstrain")}>
                <span className={cx("promoText")}>{promo.text}</span>
            </div>
        </div>
    );
};

export default HeaderPromoStrip;
